import { render, staticRenderFns } from "./ItemDetailMisc.vue?vue&type=template&id=327cd2c2&scoped=true"
import script from "./ItemDetailMisc.vue?vue&type=script&lang=js"
export * from "./ItemDetailMisc.vue?vue&type=script&lang=js"
import style0 from "./ItemDetailMisc.vue?vue&type=style&index=0&id=327cd2c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327cd2c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327cd2c2')) {
      api.createRecord('327cd2c2', component.options)
    } else {
      api.reload('327cd2c2', component.options)
    }
    module.hot.accept("./ItemDetailMisc.vue?vue&type=template&id=327cd2c2&scoped=true", function () {
      api.rerender('327cd2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/item/ItemDetailMisc.vue"
export default component.exports